import { AxiosResponse } from "axios";

import {
  CustomerUserResponseData,
  ForgotPasswordCredentials,
  OrdersAssociatedCustomerUser,
  RequestEscalation,
} from "../types";

import API from "../api";
import { CustomerPortalMilestoneStep, EstimatedInventoryCustomerPortal, OrderToCustomerPortal } from "../models/customer.portal";
import { CustomerPortalShipment } from "../models/customerPortalShipment";
import { JobDocument } from "Models/job.document";

const ROUTE_NAME = "customer/portal";

const CustomerPortalService = {
  async requestEscalation(requestEscalation: RequestEscalation): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/request/escalation`, requestEscalation);
  },

  async requestEstimatedInventory(
    jobId?: string
  ): Promise<AxiosResponse<EstimatedInventoryCustomerPortal>> {
    return await API.post(`/${ROUTE_NAME}/estimated/inventory`, { token: jobId });
  },

  async login(
    username: string,
    password: string,
    companyId: number
  ): Promise<AxiosResponse<CustomerUserResponseData>> {
    return await API.post(`/${ROUTE_NAME}/login`, { username, password, companyId });
  },

  async getOrders(options?: any) {
    return await API.get<OrderToCustomerPortal[]>(`/${ROUTE_NAME}/orders`, { params: options });
  },

  async getCount() {
    return await API.get<number>(`/${ROUTE_NAME}/orders/count`);
  },

  async getQuotes(options?: any) {
    return await API.get<OrderToCustomerPortal[]>(`/${ROUTE_NAME}/quotes`, { params: options });
  },

  async recoverPassword(recoverPasswordData?: string): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/recover`, { token: recoverPasswordData });
  },

  async forgotPassword(
    forgotPasswordCredentials: ForgotPasswordCredentials
  ): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/forgot`, forgotPasswordCredentials);
  },
  
  async getMilestoneSteps(jobId?: string): Promise<AxiosResponse<CustomerPortalMilestoneStep[]>>{
    return await API.post<CustomerPortalMilestoneStep[]>(`/${ROUTE_NAME}/milestones`, { token: jobId})
  },

  async getShipments(jobId?: string): Promise<AxiosResponse<CustomerPortalShipment[]>> {
    return await API.post<CustomerPortalShipment[]>(`${ROUTE_NAME}/shipments`, { token: jobId });
  },

  async getJobDocuments(token?: string): Promise<AxiosResponse<JobDocument[]>> {
    return await API.post(`/${ROUTE_NAME}/job-documents/list`, { token });
  }
};

export default CustomerPortalService;
